import { query, mutate, destroy, update, uploadFile } from "../../defaults/fetch";
import { useEffect, useState } from "react";
import { SERVER_URL, AUTH_TOKEN_NAME } from "../../defaults/utilities";
import { message } from "antd";
import axios from "axios";


export const useCreateUser = () => {
    const createUser = async (body) => {
        const url = `user/create`;
        const response = await mutate(url, true, body);
        return response.message;
    }

    return createUser;
}


export const useFetchUsers = (flag, page = 0, pageSize = 10, filters = {}) => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalElements, setTotalElements] = useState(0);


    useEffect(() => {
        const getAllUsers = async () => {
            setLoading(true);
            const url = `user/get-all`
            const qs = {
                page: page,
                size: pageSize,
                ...filters
            };
            const { data } = await query(url, qs);
            setLoading(false);
            setUsers(data.content);
            setTotalElements(data.totalElements || 0);
        }
        getAllUsers();
    }, [flag, page, pageSize, filters]);

    return { loading, users, totalElements };
}


export const useUpdateUser = () => {
    const updateUser = async (id, body) => {
        const url = `user/update/${id}`;
        const { message } = await update(url, body);
        return message;
    }
    return updateUser;
}

export const useDeleteUser = () => {
    const deleteUser = async (id) => {
        const url = `user/delete/${id}`;
        const { message } = await destroy(url);
        return message;
    }
    return deleteUser;
}


export const useUploadSignature = () => {
    const uploadSignature = async (payload) => {
        const url = `signature/update`;
        const { message } = await uploadFile(url, payload);
        return message
    }
    return uploadSignature;
}


export const useFetchSignature = () => {
    const token = sessionStorage.getItem(AUTH_TOKEN_NAME);

    const fetchSignature = async (userId) => {
        try {
            const url = `signature/fetch/${userId}`
            const res = await axios.get(`${SERVER_URL}/${url}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            const response = res.data;
            if (res.status !== 200) {
                return message.error("Cannot Load User signature");
            }
            return response;
        } catch (err) {
            console.log(err)
            message.error(err?.response?.data?.message ?? err.message ?? "Something went wrong")
        }
    }
    return fetchSignature;
}


export const useUpdatePassword = () => {
    const useUpdatePassword = async (payload) => {
        const url = `update-password`;
        const resp = await update(url, payload);
        return message;
    }
    return useUpdatePassword;
}



export const useGetAllUserStatuses = () => {
    const [loading, setLoading] = useState(false);
    const [statuses, setStatuses] = useState([]);

    useEffect(() => {
        const getStatuses = async () => {
            setLoading(true);
            const url = `system/get-statuses`;
            const { data } = await query(url);
            setStatuses(data);
            setLoading(false);
        }
        getStatuses();
    }, [])

    return {
        loading, statuses
    }
}

export const useSearchUsers = () => {
    const searchUsers = async (q) => {
        const url = `user/search`;
        const qs = { query: q };
        const { data } = await query(url, qs);
        return data;
    }
    return searchUsers;
}
